export default __webpack_public_path__ + "static/media/instructor-01.4636bfae.svg";